import type { ReactElement } from 'react'
import { useSelector } from 'react-redux'
import cc from 'classcat'

import { useTranslate } from '../utils/translate'

const baseClassName = 'ep-editor-save-feedback-indicator'

export default function SaveFeedbackIndicator(): ReactElement | null {
  const saveStatus = useSelector<State, string | undefined>((state) => state.getIn(['view', 'saveStatus']))

  const t = useTranslate('interface')

  if (!saveStatus) return null

  const isSaving = saveStatus === 'saving'

  const rootClassName = cc([
    baseClassName,
    {
      'is-saving': isSaving,
      'is-saved': !isSaving,
    },
  ])

  return (
    <div className={rootClassName}>
      <i className={`${baseClassName}-icon`} />
      <span className={`${baseClassName}-text`}>
        {t(`components.editorSidebarComponent.saveStatusSection.${isSaving ? 'changesSaving' : 'changesSaved'}`)}
      </span>
    </div>
  )
}
